import React, { useState, useEffect } from 'react';
import { ContentBox } from '../ContentBox';
import { SingleInput, SingleRedio, SingleText } from '../../Res/BaseInput';
import { SubmitButton } from '../../Res/BaseButton';
import { RespResumeOtherData, RespResumeOtherDataWorkExperiencesList, RespResumeOtherDataWorkExperiences } from '../../../../item/ItemResume';
import { api_addResumeOtherData } from '../../../../api/apiResume';
import Swal from 'sweetalert2';
import { getItemsInfo } from '../../../../item/ItemTools';

export const OtherData_workExperiences = "workExperiences"
export function ContractorResumeWorkExperiences({ rId, workExperiences, companyId, setIsLoading, isEdit, isEmployee = false }) {
    const [resumeId, setResumeId] = useState("")
    const [mWorkExperiences, setmWorkExperiences] = useState([])
    const [mWorkExperiencesList, setWorkExperienceList] = useState([])


    useEffect(() => {
        if (rId !== undefined && rId !== "" && rId !== resumeId) {
            setResumeId(rId)
            //console.log(rId)
            //getResumeOtherData(rId)
        }
    }, [rId])

    useEffect(() => {
        if (workExperiences !== undefined && workExperiences !== mWorkExperiences && Object.keys(workExperiences).length !== 0) {
            setmWorkExperiences(workExperiences)
            var mRespResumeOtherDataWorkExperiencesList = new RespResumeOtherDataWorkExperiencesList({})
            mRespResumeOtherDataWorkExperiencesList.fromJson(workExperiences.resumeData)
            setWorkExperienceList(mRespResumeOtherDataWorkExperiencesList.workExperiencesList)
        }
    }, [workExperiences])

    function setWorkExperiences(index, workExperiences) {
        mWorkExperiencesList[index] = workExperiences
        setWorkExperienceList(mWorkExperiencesList)
    }

    /*
    function getResumeOtherData(resumeId){
        var mReqResumeOtherData = new ReqResumeOtherData({
            resumeId,
            resumeKey: OtherData_education
        })
        //console.log(mReqResumeOtherData)
        api_getResumeOtherData({
            mReqResumeOtherData,
            success:(jsonData)=>{
                //console.log(jsonData.info.resumeData)
                var mRespResumeOtherDataWorkExperiencesList = new RespResumeOtherDataWorkExperiencesList({})
                mRespResumeOtherDataWorkExperiencesList.fromJson(jsonData.info.resumeData)
                //console.log(mRespResumeOtherDataWorkExperiencesList)
                setWorkExperienceList(mRespResumeOtherDataWorkExperiencesList.workExperiencesList)
                setIsLoading(false)
            },
            failure:(err)=>{
                setIsLoading(false)
            }
        })
    }
    */

    async function saveOtherDataFamily() {
        //console.log("saveOtherData")
        var mRespResumeOtherData = new RespResumeOtherData({
            companyId,
            resumeId,
            resumeKey: OtherData_workExperiences,
            resumeData: JSON.stringify(mWorkExperiencesList),
        })
        //console.log(mRespResumeOtherData)
        try {
            await api_addResumeOtherData({
                mRespResumeOtherData,
                isEmployee
            })
            Swal.fire({
                type: 'success',
                title: '提醒',
                text: "儲存成功",
            })
        } catch (error) {
            console.log(error)
        }
    }


    var title = "工作經歷"
    var content =
        <>
            {
                mWorkExperiencesList.map((f, i) => (
                    <WorkExperiencesItems key={"we" + i} index={i} workExperiences={f} setWorkExperiences={setWorkExperiences} isEdit={isEdit} />
                ))
            }
            {isEdit ?
                <>
                    <div className="hr-line-dashed"></div>
                    <div className="row text-right ">
                        <div className="col-sm-12">
                            <SubmitButton name={"儲存"} action={saveOtherDataFamily} isRight={true} />
                        </div>
                    </div>
                </>
                : <></>
            }
        </>


    return (
        <>
            <ContentBox title={title} content={content} hasDrawer={true} />
        </>
    )
}

function WorkExperiencesItems({ index, workExperiences, setWorkExperiences, isEdit }) {
    const [mWorkExperiences, setW] = useState(new RespResumeOtherDataWorkExperiences({}))
    const [companyName, setCompanyName] = useState("")
    const [workContent, setWorkContent] = useState("")
    const [salary, setSalary] = useState("")
    const [during, setDuring] = useState("")
    const [reasonsLeaving, setReasonsLeaving] = useState("")
    const [jobContract, setJobContract] = useState(0)
    const placeholder = ["請填寫最近工作公司名稱", "請填寫次近工作公司名稱"]
    const jobContractItems = [{ "val": 1, "name": "正職" }, { "val": 2, "name": "派遣" }]

    useEffect(() => {
        if (workExperiences !== undefined && workExperiences !== mWorkExperiences) {
            setW(workExperiences)
            setCompanyName(workExperiences.companyName)
            setWorkContent(workExperiences.workContent)
            setSalary(workExperiences.salary)
            setDuring(workExperiences.during)
            setReasonsLeaving(workExperiences.reasonsLeaving)
            setJobContract(workExperiences.jobContract)
        }
    }, [workExperiences])

    function setN(val) {
        setCompanyName(val)
        mWorkExperiences.companyName = val
        setWorkExperiences(index, mWorkExperiences)
    }
    function setWC(val) {
        setWorkContent(val)
        mWorkExperiences.workContent = val
        setWorkExperiences(index, mWorkExperiences)
    }
    function setS(val) {
        setSalary(val)
        mWorkExperiences.salary = val
        setWorkExperiences(index, mWorkExperiences)
    }
    function setD(val) {
        setDuring(val)
        mWorkExperiences.during = val
        setWorkExperiences(index, mWorkExperiences)
    }
    function setR(val) {
        setReasonsLeaving(val)
        mWorkExperiences.reasonsLeaving = val
        setWorkExperiences(index, mWorkExperiences)
    }
    function setJ(val) {
        setJobContract(val)
        mWorkExperiences.jobContract = val
        setWorkExperiences(index, mWorkExperiences)
    }

    return (
        <>
            {index === 0 ? <></> : <div className="hr-line-dashed"></div>}
            <div className="row  m-b-sm">
                <div className="col-md-12">
                    {isEdit ?
                        <SingleInput title={"服務機關"} val={companyName} action={setN} placeholder={placeholder[index]} size={4} />
                        : <SingleText title={"服務機關"} val={companyName} />
                    }
                    {isEdit ?
                        <SingleInput title={"工作內容"} val={workContent} action={setWC} placeholder={"請填寫工作內容"} size={4} />
                        : <SingleText title={"工作內容"} val={workContent} />
                    }
                    {isEdit ?
                        <SingleInput title={"薪資待遇"} val={salary} action={setS} placeholder={"30,000"} size={4} />
                        : <SingleText title={"薪資待遇"} val={salary} />
                    }
                </div>
                <div className="col-md-12">
                    {isEdit ?
                        <SingleInput title={"就職期間"} val={during} action={setD} placeholder={"201109/201306"} size={4} />
                        : <SingleText title={"就職期間"} val={during} />
                    }
                    {isEdit ?
                        <SingleInput title={"離職原因"} val={reasonsLeaving} action={setR} placeholder={"請填寫工作內容"} size={4} />
                        : <SingleText title={"離職原因"} val={reasonsLeaving} />
                    }
                    {isEdit ?
                        <SingleRedio title={"職缺合約"} arr={jobContractItems} val={jobContract} action={setJ} />
                        : <SingleText title={"職缺合約"} val={getItemsInfo({ items: jobContractItems, val: jobContract })} />
                    }
                </div>
            </div>
        </>
    )
}
